import { gql } from '@apollo/client'

export const CREATE_COLOR = gql`
  mutation createColor($input: CreateColorInput!) {
    data: createColor(input: $input) {
      id
    }
  }
`
